import * as React from 'react'
function SvgArrowRight(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M22.893 7.307L22.2 8a1.98 1.98 0 000 2.8l7.2 7.2H7a2 2 0 100 4h22.4l-7.2 7.2A1.98 1.98 0 0025 32l9.879-9.879a3 3 0 000-4.242L24.307 7.307a1 1 0 00-1.414 0z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgArrowRight
